import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Check } from 'lucide-react';
export function PersonalPage() {
  return <div className="bg-brand-beige" data-id="element-814">
      <PageHero title="The Jolu Circle" subtitle="An exclusive membership for our most dedicated patrons." backgroundImage="https://images.unsplash.com/photo-1559339352-11d035aa65de?w=1920&q=80" data-id="element-815" />

      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-816">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-817"></div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-818">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-819">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-820">
              <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-821">
                Perks & Benefits
              </h2>
              <div className="w-16 h-1 bg-brand-gold mb-10" data-id="element-822"></div>

              <ul className="space-y-6 mb-16" data-id="element-823">
                {['Priority reservations across all JJ Group restaurants, even on fully booked nights.', 'Invitations to exclusive quarterly tasting events and chef dinners.', 'Complimentary premium dining experience for your birthday.', 'Dedicated 24/7 concierge service for all your hospitality needs.', '10% preferred pricing on all retail and Grab & Go items.'].map((perk, i) => <li key={i} className="flex items-start gap-4 text-brand-dark/80 text-lg font-light" data-id="element-824">
                    <div className="mt-1 bg-brand-gold/20 p-1 rounded-full text-brand-gold shrink-0" data-id="element-825">
                      <Check size={16} strokeWidth={3} data-id="element-826" />
                    </div>
                    {perk}
                  </li>)}
              </ul>

              <h3 className="text-2xl font-serif text-brand-dark mb-6" data-id="element-827">
                How It Works
              </h3>
              <div className="space-y-6" data-id="element-828">
                <div className="flex gap-6" data-id="element-829">
                  <div className="text-3xl font-serif text-brand-gold" data-id="element-830">01</div>
                  <div data-id="element-831">
                    <h4 className="font-medium text-brand-dark mb-1 uppercase tracking-widest text-sm" data-id="element-832">
                      Apply
                    </h4>
                    <p className="text-brand-dark/70 font-light text-sm" data-id="element-833">
                      Submit your application for review by our membership
                      committee.
                    </p>
                  </div>
                </div>
                <div className="flex gap-6" data-id="element-834">
                  <div className="text-3xl font-serif text-brand-gold" data-id="element-835">02</div>
                  <div data-id="element-836">
                    <h4 className="font-medium text-brand-dark mb-1 uppercase tracking-widest text-sm" data-id="element-837">
                      Welcome
                    </h4>
                    <p className="text-brand-dark/70 font-light text-sm" data-id="element-838">
                      Upon acceptance, receive your physical black card and
                      welcome gift.
                    </p>
                  </div>
                </div>
                <div className="flex gap-6" data-id="element-839">
                  <div className="text-3xl font-serif text-brand-gold" data-id="element-840">03</div>
                  <div data-id="element-841">
                    <h4 className="font-medium text-brand-dark mb-1 uppercase tracking-widest text-sm" data-id="element-842">
                      Enjoy
                    </h4>
                    <p className="text-brand-dark/70 font-light text-sm" data-id="element-843">
                      Begin utilizing your dedicated concierge immediately.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div className="bg-brand-dark p-10 md:p-14 rounded-sm shadow-2xl relative" initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-844">
              <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-845"></div>
              <div className="relative z-10" data-id="element-846">
                <h3 className="text-3xl font-serif text-white mb-2" data-id="element-847">
                  Apply for Membership
                </h3>
                <p className="text-white/50 font-light mb-8 text-sm" data-id="element-848">
                  Membership is currently limited to maintain the quality of
                  service.
                </p>

                <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-849">
                  <div data-id="element-850">
                    <input type="text" placeholder="Full Name" className="w-full bg-transparent border-b border-white/20 py-3 text-white focus:outline-none focus:border-brand-gold transition-colors" data-id="element-851" />
                  </div>
                  <div data-id="element-852">
                    <input type="email" placeholder="Email Address" className="w-full bg-transparent border-b border-white/20 py-3 text-white focus:outline-none focus:border-brand-gold transition-colors" data-id="element-853" />
                  </div>
                  <div data-id="element-854">
                    <input type="tel" placeholder="Phone Number" className="w-full bg-transparent border-b border-white/20 py-3 text-white focus:outline-none focus:border-brand-gold transition-colors" data-id="element-855" />
                  </div>
                  <div data-id="element-856">
                    <textarea rows={3} placeholder="Why would you like to join The Jolu Circle?" className="w-full bg-transparent border-b border-white/20 py-3 text-white focus:outline-none focus:border-brand-gold transition-colors resize-none" data-id="element-857"></textarea>
                  </div>
                  <button className="w-full bg-brand-gold text-brand-dark py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-white transition-colors mt-4" data-id="element-858">
                    Submit Application
                  </button>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}